module["exports"] = [
  "Pty Ltd",
  "and Sons",
  "Corp",
  "Group",
  "Brothers",
  "Partners"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_AU/company/suffix.js
 ** module id = 486
 ** module chunks = 0
 **/